
<template>

    <main v-if="auth.type === 'admin'">

        <transition name="modal">
            <modal
                :manager_id="modal_manager_id"
                @close="() => {
                    modal_manager_id = null
                    refresh()
                }"
                v-if="modal_manager_id"
            />
        </transition>

        <button class="btn btn-primary btn-register" @click="createManager()" :disabled="loadingCreateManager == true">
            <span class="spinner-border spinner-border-sm me-1"></span>
            <img src="/images/card/register-button-icon.svg">
            Lägg till
        </button>

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body employee-body">

            <div class="container-fluid">
                <h1 class="mb-8">{{ pageTitle }}</h1>

                <div class="row mb-5">
                    <div class="col-24 col-sm-14 col-md-10 col-xl-6">
                        <input type="text"
                               class="form-control form-control-list"
                               placeholder="Sök användare..."
                               v-model="settings.query.text">
                    </div>

                    <div class="col-md-14 col-xl-18 d-none d-lg-flex justify-content-end align-content-start">
                        <button class="btn btn-primary me-2" @click="createManager()" :disabled="loadingCreateManager == true">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            + Lägg till
                        </button>
                    </div>

                </div>

                <list ref="list" :settings="settings" :query.sync="settings.query" :useCookies="false">
                    <div slot="item-row" slot-scope="props">
                        <div class="row g-3" :class="{'inactive': props.item.disabled_at }">
                            <div class="col-16 col-md-7 col-xl-5">
                                <span>{{ props.item.name }}</span>
                            </div>
                            <div class="col-md-11 col-xl-6 d-none d-md-flex">
                                <span>{{ props.item.email }}</span>
                            </div>
                            <div class="col-xl-5 d-none d-xl-flex">
                                <span v-if="props.item.type === 'admin'">
                                    Administratör
                                </span>
                                <span v-if="props.item.type === 'regular'">
                                    Användare
                                </span>
                            </div>
                            <div class="col-xl-4 d-none d-xl-flex">
                                <span>{{ props.item.created_at }}</span>
                            </div>
                            <div class="col-8 col-md-6 col-xl-4 d-flex justify-content-end">

                                <span v-if="props.item.disabled_at">
                                    <poster-button
                                        btn-class="btn btn-outline-info btn-sm"
                                        :url="'/data/managers/' + props.item.id + '/disableAccount'"
                                        @success="activateSuccess()">
                                        <span v-if="props.item.disabled_at">Återaktivera kontot</span>
                                        <span v-else>Inaktivera kontot</span>
                                    </poster-button>
                                </span>
                                <span v-else> 
                                    <poster-button
                                        btnClass="btn btn-outline-primary btn-sm me-1"
                                        :url="'/data/managers/' + props.item.id + '/sendForgotPassword'"
                                        @success="sendForgotPasswordSuccess()">
                                        <img src="/images/company-portal/icon-renew.svg" class="inactive">
                                        <img src="/images/company-portal/icon-renew-white.svg" class="active">
                                        <div class="tooltip-label">Skicka en notis med återställningslänk för lösenord.</div>
                                    </poster-button>

                                    <button class="btn btn-outline-primary btn-sm" @click="modal_manager_id = props.item.id">
                                        <img src="/images/company-portal/icon-edit.svg" class="d-sm-none">
                                        <span class="d-none d-sm-block">Hantera</span>
                                        <div class="tooltip-label">Redigera uppgifter, visa lista på behandlingar eller ta bort kontot.</div>
                                    </button>
                                </span>

                            </div>
                        </div>
                    </div>
                </list>

            </div>

        </div>

    </main>

</template>

<script>

import scrollMixin from '../../../shared/mixins/scrollMixin'
import lister from '../../../shared/mixins/lister'
import posterButton from '../../../shared/components/poster-button'

import modal from './modal'
import axios from 'axios'
import PosterButton from '../../../shared/components/poster-button'

export default {

    mixins: [
        scrollMixin,
        lister
    ],

    components: {
        PosterButton,
        modal
    },

    data () {
        return {
            pageTitle: 'Användare',
            modal_manager_id: null,
            loadingCreateManager:false,
            settings: {
                url: '/data/managers/list',
                query: {
                    text: ''
                },
                columns: [
                    { column: 'name', name: 'Namn', class: 'col-16 col-md-7 col-xl-5', sortable: true, default: true },
                    { column: 'email', name: 'E-postadress', class: 'col-md-11 col-xl-6 d-none d-md-flex', sortable: true },
                    { column: 'created_at', name: 'Behörighet', class: 'col-xl-5 d-none d-xl-flex', sortable: true },
                    { column: 'created_at', name: 'Konto skapat', class: 'col-xl-4 d-none d-xl-flex', sortable: true }
                ],
                bulk_actions: []
            }
        }
    },

    methods: {
        
        createManager () {
            this.loadingCreateManager = true
            var self = this
            axios.post('/data/managers')
                .then(response => {
                    this.modal_manager_id = response.data.manager_id
                    self.loadingCreateManager = false
                })
        },
        activateSuccess () {
            this.refresh()
            bus.$emit(
                'notify',
                'Kontot har återaktiverats'
            )
        },
        sendForgotPasswordSuccess () {
            bus.$emit(
                'notify',
                'Återställningslänk har skickats via e-post'
            )
        },
    }
}
</script>
<style type="text/css">
/* --- Fade transition --- */
.modal-enter-active, .modal-leave-active {
    opacity: 1;
    transition: all 250ms;
}

.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 250ms;
}

.modal-enter, .modal-leave-to {
    opacity: 0;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, -50px);
}

@media only screen and (max-width: 768px){

    .modal-enter, .modal-leave-to {
        opacity: 1;
    }

    .modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
        transform:translate(0, 100%);
    }

}
</style>
